import Vue from "vue";
export default Vue.extend({
    components: {
        TheTopNav: function () {
            return import("../../components/topNav.vue");
        }
    },
    data: function () {
        return {
            role: JSON.parse(sessionStorage.getItem("token") || "{}"),
            navList: [
                { name: "首页", path: "/Student/home" },
                { name: "政策分析", path: "/Student/policyAnalyze" }
            ]
        };
    }
});
